import React from 'react';
import { Search, Bell, Menu } from 'lucide-react';
import { Tenant } from '../../types';
interface HeaderProps {
  currentView: 'admin' | 'club';
  currentPage: string;
  tenant?: Tenant;
}
export function Header({
  currentView,
  currentPage,
  tenant
}: HeaderProps) {
  const getPageTitle = () => {
    const titles: Record<string, string> = {
      dashboard: 'Dashboard',
      tenants: 'Tenants Übersicht',
      'tenant-detail': 'Tenant Details',
      'network-companies': 'Unternehmensverzeichnis',
      'network-people': 'Personenverzeichnis',
      'company-profile': 'Unternehmensprofil',
      'person-profile': 'Personenprofil',
      events: 'Events & Termine',
      'event-detail': 'Event Details',
      feed: 'Netzwerk Feed',
      messages: 'Nachrichten',
      challenges: 'Challenges & Badges',
      settings: 'Einstellungen'
    };
    return titles[currentPage] || 'Connectra';
  };
  return <header className="h-16 bg-white border-b border-slate-200 flex items-center justify-between px-6 sticky top-0 z-10" data-id="element-25">
      <div className="flex items-center gap-4" data-id="element-26">
        <button className="lg:hidden text-slate-500 hover:text-slate-700" data-id="element-27">
          <Menu size={24} data-id="element-28" />
        </button>

        <div className="flex items-center gap-2" data-id="element-29">
          {currentView === 'club' && tenant && <div className="hidden md:flex items-center gap-2 mr-4 pr-4 border-r border-slate-200" data-id="element-30">
              <span className="text-xl" data-id="element-31">{tenant.logo}</span>
              <span className="font-semibold text-slate-800" data-id="element-32">
                {tenant.name}
              </span>
            </div>}
          <h1 className="text-xl font-bold text-slate-800" data-id="element-33">{getPageTitle()}</h1>
        </div>
      </div>

      <div className="flex items-center gap-6" data-id="element-34">
        <div className="relative hidden md:block" data-id="element-35">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" size={18} data-id="element-36" />
          <input type="text" placeholder="Suchen..." className="pl-10 pr-4 py-2 bg-slate-100 border-transparent rounded-full text-sm focus:bg-white focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 transition-all w-64 outline-none" data-id="element-37" />
        </div>

        <button className="relative text-slate-500 hover:text-slate-700 transition-colors" data-id="element-38">
          <Bell size={20} data-id="element-39" />
          <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-red-500 rounded-full border-2 border-white" data-id="element-40"></span>
        </button>

        <div className="w-8 h-8 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center font-bold text-sm cursor-pointer border border-emerald-200" data-id="element-41">
          AD
        </div>
      </div>
    </header>;
}